const customStyles = {
	menu: (provided, state) => ({
		...provided,
		color: "#fff !important",
		background: "var(--sidebar-hover) !important",
	}),

	option: (styles, props) => ({
		...styles,
		color: "#fff !important",
		backgroundColor: props.isDisabled
			? null
			: props.isSelected
			? "black"
			: props.isFocused
			? "var(--color-blackPurple)"
			: "transparent",
	}),
	singleValue: (provided) => ({
		...provided,
		color: "black",
	}),
	menuList: (base) => ({
		...base,
		".css-gg45go-NoOptionsMessage": {
			color: "#fff !important",
		},
	}),
	control: (base, props) => ({
		...base,
		backgroundColor: "#fff !important",

		input: {
			outline: "0px !important",
			border: "0px !important",
			boxShadow: "none !important",
			"&:focus": {
				outline: "0px !important",
				border: "0px !important",
				boxShadow: "none !important",
			},
		},

		"&:focus-within": {
			border: "none",
		},
	}),
	multiValue: (base, props) => ({
		...base,
		fontSize: "16px",
	}),
};
export { customStyles };
